import m from "@knocklabs/client";
import u from "react";
import "../context/KnockProvider.mjs";
import l from "./useStableOptions.mjs";
import "date-fns";
function f(i, n, r, t = {}) {
  i.authenticate(n, r, {
    onUserTokenExpiring: t == null ? void 0 : t.onUserTokenExpiring,
    timeBeforeExpirationInMs: t == null ? void 0 : t.timeBeforeExpirationInMs
  });
}
function E(i, n, r, t = {}) {
  const a = u.useRef(), c = l(t);
  return u.useMemo(() => {
    const e = a.current;
    if (e && e.isAuthenticated() && (e.userId !== n || e.userToken !== r))
      return f(e, n, r, c), e;
    e && e.teardown();
    const o = new m(i, {
      host: c.host,
      logLevel: c.logLevel
    });
    return f(o, n, r, c), a.current = o, o;
  }, [i, n, r, c]);
}
export {
  E as default
};
//# sourceMappingURL=useAuthenticatedKnockClient.mjs.map
